import * as React from 'react';
import { createViewConfig } from '@sail/engine';
import { css } from '@sail/ui';
export const HelmIconConfig = createViewConfig({
    props: {},
    name: 'HelmIcon',
    flattens: true,
    defaults: {
        'aria-hidden': true
    }
});
export const HelmIcon = HelmIconConfig.createView(({ icon: SvgElem, ...props })=>{
    return /*#__PURE__*/ React.createElement(SvgElem, props);
}, {
    uses: [
        css({
            display: 'block'
        })
    ]
});

//# sourceMappingURL=HelmIcon.js.map